import React, {useEffect} from "react";
import { motion } from "framer-motion";

const imageVariants = {
  hidden: { y: "50%" },
  visible: {
    y: 0,
    transition: {
      type: "spring",
      bounce: 0.6,
      duration: 2,
    },
  },
};

const SecondSection = () => {

  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    const section = document.getElementById('second');
    section.addEventListener('contextmenu', handleContextMenu);

    return () => {
      section.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  return (


    <div className="secondSection" id="second">
      <span className="grey">Exploring My Identity</span>
      <h1> About Me </h1>

      <div className="about">
        <motion.div
          className="profile-photo-container"
          variants={imageVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <img
            className="profile-photo"
            src="images/me2.png"
            alt="profile-pic"
          />
        </motion.div>
        <motion.div
          variants={imageVariants}
          initial={{ opacity: 0, y: "50%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, y: "100%" }}
          whileInView="visible"
          viewport={{ once: true }}
        >
          <div className="about-text">
            <h2>
              Passionate about the intersection of mechanics and technology.
            </h2>
            <h3>Full Stack Web Developer with expertise in MERN stack. </h3>
            <p>
              As a Mechanical Engineering student, my love for Physics,
              Mathematics, and machines has given me a unique perspective and a
              set of problem-solving skills that I bring to the table.
            </p>
            <p>
              My pursuit of exploring new avenues of technology led me to delve
              into the exciting field of Blockchain Development, where I aim to
              contribute my skills and expertise.
              <p>
                I am proficient in front-end languages such as HTML, CSS,
                JavaScript, and React.js, and for back-end development, I use
                Node.js, MongoDB, and Express.
              </p>
            </p>
          </div>
        </motion.div>
      </div>
      {/* <motion.div
        variants={imageVariants}
        initial={{ x: "10%" }}
        whileInView="visible"
        viewport={{ once: true }}
      >
        <img src="images/3d-img3.png" className="threeD-image3" />
      </motion.div> */}
    </div>
  );
};

export default SecondSection;
